import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as markdown from '@attain-apps/fe/web/main/lib/markdown'

import type { Feature } from './feature'
import * as models from './models'

/**
 * Used to render links to DMS models in Markdown
 *
 * @see {@link markdown.Extension.register}
 */
export function registerMarkdownExtension(feature: Feature) {
  markdown.Extension.register(
    'summit-org-chart',
    ({ body, properties: { name } }) => ({
      init: element => {
        ;(element as HTMLElement).onclick = () => {
          feature.actions.propose
            .from(`AssistantProposal.Clicked`)
            .dispatch(models.Data.fromXml(body))
        }
      },
      // NOTE: JSON.stringify ensures the results are quoted, which helps
      // prevent XSS, as well as just accidental improper formatting
      innerHtml: `<div class="atn-org-chart-proposal">
  <h5 class="atn-org-chart-proposal__header">Proposal</h5>
  <p class="atn-org-chart-proposal__name">${JSON.stringify(name)}</p>
</div>`,
      styles: `.atn-org-chart-proposal {
  border: solid 1px ${ds.color.Scale.SHADOW.darker};
  background: ${ds.color.Scale.SHADOW.lightest};
  color: ${ds.color.Scale.SHADOW.darkest};
  font-size: 13px;
  border-radius: 5px;
  padding: 5px 8px;
  margin: 15px 5px;
  text-align: center;
  cursor: pointer;
}

.atn-org-chart-proposal__header, .atn-org-chart-proposal__name {
  font-size: 13px;
}`,
    }),
  )
}
